module.exports = "/images/ilustracion1.svg?89fc44b02537ff7fa882d368f4a117e4";